import { useFormItemEnabled } from '@framework/form/item/useFormItemEnabled.ts';
import { useEffect, useRef } from 'react';
import { type Subject } from 'rxjs';
import { type MapSubjectEvent } from '../MapWidgetComponent.tsx';

export interface IMapDisabledHandlerProps {
  mapSubject: Subject<MapSubjectEvent>;
}

/**
 * Componente per reimpostare i campi della mappa quando l'input è
 * disabilitato.
 */
export function MapDisabledHandler(props: IMapDisabledHandlerProps) {
  const { mapSubject } = props;
  const { enabled } = useFormItemEnabled();

  const enabledRef = useRef(enabled);
  useEffect(() => {
    if (enabledRef.current !== enabled && !enabled) {
      mapSubject.next({
        type: 'reset',
      });
    }
    enabledRef.current = enabled;
  }, [enabled, mapSubject]);

  return null;
}
